export default __webpack_public_path__ + "static/blob1-be4a385d5b596811c871f64a35cec959.svg";